import "bootstrap-icons/font/bootstrap-icons.css";
import { LinkButton } from "components/buttons";
import EnquiryForm from "components/forms/EnquiryForm";
import { JumbotronUmrah } from "sections";
import { Col, Row } from "react-bootstrap";
import outline_check from "assets/images/outline_check.svg";
import { eligibility } from "constants/eligibility";
import parse from "html-react-parser";
import { ASSETS_BASE_URL } from "constants";
import { handleOpenPdf } from "utils";

function PersonalFinancingUmrah() {
  return (
    <div>
      <section className="section jumbotron">
        <JumbotronUmrah
          badgeText="Pembiayaan Peribadi-i"
          title={`    <span className="jumbotron-subtitle-2">
                Pembiayaan Peribadi-<i>i</i>  
                           </span> Umrah
             
             `}
          buttonText="Berhubung dengan kami! "
        />
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Perkara</h3>
          </div>
          <div className="col-xl-8">
            <p>
              Kemudahan pembiayaan demi merealisasikan impian anda dan keluarga
              tersayang untuk menunaikan ibadah umrah. Umrah bersama keluarga
              kini menjadi lebih mudah!
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Manfaat</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">5.94%* setahun</div>
                <div className="column-subheader-2">
                  Kadar pembiayaan serendah 5.94% setahun{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Had Pembiayaan</div>
                <div className="column-subheader-2">
                  Had pembiayaan sehingga RM250,000{" "}
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Tempoh Pembiayaan</div>
                <div className="column-subheader-2">
                  Tidak memerlukan cagaran atau penjamin{" "}
                </div>
              </div>

              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Penjamin</div>
                <div className="column-subheader-2">
                  Affordable payment terms
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Perlindungan Takaful</div>
                <div className="column-subheader-2">
                  Pilihan untuk Perlindungan Takaful Kemalangan Diri{" "}
                </div>
              </div>
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Panel Agensi</div>
                <div className="column-subheader-2">
                  Umrah bersama panel Agensi Pelancongan yang berdaftar dan
                  mempunyai rekod prestasi yang terbukti
                </div>
              </div>
            </div>
            <p className="pt-3">*Tertakluk kepada terma dan syarat</p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "flex-start" }}>
          <div className="col-xl-4">
            <h3>Kontrak Shariah</h3>
          </div>
          <div className="col-xl-8">
            <div className="row">
              <div className="col-xl-3 col-12 custom-column-2">
                <div className="column-header-2">Kontrak Shariah</div>
                <div className="column-subheader-2">
                  Komoditi Murabahah (Tawarruq){" "}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <Row>
          <Col md={4}>
            <h3>Kelayakan</h3>
          </Col>
          <Col md={8}>
            <div>
              {eligibility.points.eligibilityumrah.description.map(
                (benefit, index) => (
                  <div className="animated-list">
                    <div className="check">
                      <img src={outline_check} width="22" alt="outline_check" />
                    </div>
                    <div
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  </div>
                )
              )}
            </div>
          </Col>
        </Row>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Dokumen Pendapatan Diperlukan</h3>
          </div>
          <div className="col-xl-8">
            <p>
              <i
                className="bi bi-check-circle "
                style={{
                  fontSize: "20px",
                  paddingRight: "20px",
                  color: "#221AFB",
                }}
              ></i>
              <b>Penyata KWSP</b> terkini
            </p>
            <p>
              <i
                className="bi bi-check-circle "
                style={{
                  fontSize: "20px",
                  paddingRight: "20px",
                  color: "#221AFB",
                }}
              ></i>
              <b>Slip gaji 3 bulan terkini</b> dan penyata bank yang menunjukkan
              pengkreditan gaji
            </p>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Manfaat yang akan diperoleh oleh Jemaah</h3>
          </div>
          <div className="col-xl-8">
            <p>
              <i
                className="bi bi-check-circle "
                style={{
                  fontSize: "25px",
                  paddingRight: "20px",
                  color: "#221AFB",
                }}
              ></i>
              Jaringan <b>kemudahan perbankan terbesar </b> di tanah suci
            </p>
            <p>
              <i
                className="bi bi-check-circle "
                style={{
                  fontSize: "25px",
                  paddingRight: "20px",
                  color: "#221AFB",
                }}
              ></i>
              Pakej yang memberi{" "}
              <b>kemudahan untuk membawa keluarga tersayang</b> untuk menunaikan
              ibadah Umrah
            </p>
            <p>
              <i
                className="bi bi-check-circle "
                style={{
                  fontSize: "25px",
                  paddingRight: "20px",
                  color: "#221AFB",
                }}
              ></i>
              <b>Kadar menarik</b> bagi produk Pembiayaan Peribadi-<em>i</em>{" "}
              Umrah
            </p>
            <div className="link-button-row pt-5">
              <LinkButton
                text="Personal Financing-i Application Form"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF_application_form.pdf`
                  )
                }
              />
              <LinkButton
                text="Product Disclosure Sheet"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/PDS-PF(Mass).pdf`
                  )
                }
              />
              <LinkButton
                text="Appendix 1 - Balance Transfer Program"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/Appendix 1 - Balance Transfer Program.pdf`
                  )
                }
              />
              <LinkButton
                text="Appendix 2 - Deduction Form (English)"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF Appendix 2 Deduction Form ENG - Final.pdf`
                  )
                }
              />
              <LinkButton
                text="Appendix 2 - Deduction Form (Bahasa Melayu)"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF Appendix 2 Deduction Form BM -Final.pdf`
                  )
                }
              />
              <LinkButton
                text="Appendix 3 - Supplemental Terms (English)"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/PF Appendix 3.pdf`
                  )
                }
              />
              <LinkButton
                text="Appendix 3 - Supplemental Terms (Bahasa Melayu)"
                onClick={() =>
                  handleOpenPdf(
                    `${ASSETS_BASE_URL}assets/pdf/personal-financing/BM_3 Clean Appendix 3.pdf`
                  )
                }
              />
            </div>
          </div>
        </div>
      </section>

      <section className="section about container">
        <div className="row" style={{ justifyContent: "center" }}>
          <div className="col-xl-4">
            <h3>Berhubung dengan kami </h3>
            <p>
              Sila isikan butiran anda dan wakil perkhidmatan kami akan hubungi
              anda.
            </p>
          </div>
          <div className="col-xl-8">
            <EnquiryForm />
          </div>
        </div>
      </section>
    </div>
  );
}

export default PersonalFinancingUmrah;
